import { Record } from 'immutable';

const CompanyInfoRecord = Record({
  type: '',
  name: '',
  legalName: '',
  taxNumber: '',
  registrationNumber: '',
});

export default class CompanyInfo extends CompanyInfoRecord {
  static deserialize(jsonObject = {}) {
    return new CompanyInfo(jsonObject);
  }
}
